import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore, useToggle } from 'hooks';
import { ScrollableModal, SVG } from 'components';
import { Dropdown, Link, Text } from 'components/ui';
import { AddUrlWindow } from './components';
import { Wrapper } from './tab-info.styled';
import { Icons } from 'assets';

type TabInfoProps = {
  slug: string;
};

export const TabInfo = observer(({ slug }: TabInfoProps) => {
  const { user, tabs } = useStore();
  const [isEditUrlOpen, toggleEditUrlOpen] = useToggle();

  useEffect(() => {
    if (tabs.requestsStates.linkTab.readyToLoad) {
      tabs.getTabLinks();
    }

    return () => {
      tabs.hardResetCurrentTab();
    };
  }, [tabs]);

  const link = tabs.currentLinks(slug);

  if (!slug || !link) {
    return null;
  }

  if (!user.isSuperUser) {
    return (
      <Wrapper>
        <Link
          leftIcon={<SVG src={Icons.QuestionCircle} />}
          href={link.help_link}
          target="_blank"
          color="gray"
          underline
          style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
        >
          Помощь по разделу
        </Link>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <Link
            asButton
            leftIcon={<SVG src={Icons.QuestionCircle} />}
            color="gray"
            underline
            style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
          >
            Помощь по разделу
          </Link>
        </Dropdown.Trigger>

        <Dropdown.Portal>
          <Dropdown.Content align="start">
            <Dropdown.Item onSelect={() => window.open(link.help_link)}>
              <SVG src={Icons.ArrowUpRight} />
              <Text>Открыть помощь</Text>
            </Dropdown.Item>

            <Dropdown.Item $critical onSelect={toggleEditUrlOpen}>
              <SVG src={Icons.Gear} />
              <Text>Изменить URL-адрес</Text>
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>

      <ScrollableModal
        isOpen={isEditUrlOpen}
        onClose={toggleEditUrlOpen}
        size="s"
      >
        <AddUrlWindow onClose={toggleEditUrlOpen} slug={slug} link={link} />
      </ScrollableModal>
    </Wrapper>
  );
});
